<template>
  <div :style="{ height: `${height}px` }">
    <strong>Menor valor:</strong> {{ min }}<br/>
    <strong>Maior valor:</strong> {{ max }}<br/>
    <strong>Média:</strong>       {{ avg }}<br/>
    <strong>Peso:</strong>        {{ weight_value }}<br/>
  </div>
</template>

<script>
export default {
  name: 'AvaliationNumberChart',
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      default: 110,
    },
  },
  computed: {
    min() {
      if (!this.chartData || !this.chartData.data) return 0;
      return (parseFloat(this.chartData.data.min) || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 })
    },
    avg() {
      if (!this.chartData || !this.chartData.data) return 0;
      return (parseFloat(this.chartData.data.avg) || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 })
    },
    max() {
      if (!this.chartData || !this.chartData.data) return 0;
      return (parseFloat(this.chartData.data.max) || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 })
    },
    weight_value() {
      if (!this.chartData || !this.chartData.data) return 0;
      return (parseFloat(this.chartData.data.weight_value) || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 })
    },
    wavg() {
      if (!this.chartData || !this.chartData.data) return 0;
      return (parseFloat(this.chartData.data.wavg) || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 })
    }
  }
}

</script>
